import React from "react";

const FormMenuBtnSvg = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="8" height="2.8" rx="1.4" fill="#969FA8"/>
      <rect x="4" y="10.6" width="16" height="2.8" rx="1.4" fill="#969FA8"/>
      <rect x="4" y="17.0996" width="12" height="2.8" rx="1.4" fill="#969FA8"/>
    </svg>
  )
};

export default FormMenuBtnSvg;
